module.exports = __webpack_public_path__ + "img/500.669aaa8f.svg";